export default function getDaysBetween(dateFrom: string, dateTo: string): string[] {
    const daysOfWeek: string[] = []
    const startDate = new Date(dateFrom)
    const endDate = new Date(dateTo)

    for (
        let currentDate = new Date(startDate);
        currentDate <= endDate;
        currentDate.setDate(currentDate.getDate() + 1)
    ) {
        const year = currentDate.getFullYear()
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
        const day = currentDate.getDate().toString().padStart(2, '0')

        daysOfWeek.push(`${year}-${month}-${day}`)
    }

    return daysOfWeek
}
